import { useEffect } from 'react';

/**
 * Hook to set document title
 * @param {string} title - The title to set for the document
 */
const useDocumentTitleHook = (title) => {
  useEffect(() => {
    if (title) {
      document.title = `Admin Portal - ${title.charAt(0).toUpperCase() + title.slice(1)}`;
    }
  }, [title]);
};

export default useDocumentTitleHook;
